import { DOMAIN_NAME } from './common';

// Menu actions
const FETCH_MENUS = `${DOMAIN_NAME}@FETCH_MENUS`;
const FETCH_MENUS_SUCCESS = `${DOMAIN_NAME}@FETCH_MENUS_SUCCESS`;
const FETCH_MENUS_FAILURE = `${DOMAIN_NAME}@FETCH_MENUS_FAILURE`;

const FETCH_MENU_BY_ID = `${DOMAIN_NAME}@FETCH_MENU_BY_ID`;
const FETCH_MENU_BY_ID_SUCCESS = `${DOMAIN_NAME}@FETCH_MENU_BY_ID_SUCCESS`;
const FETCH_MENU_BY_ID_FAILURE = `${DOMAIN_NAME}@FETCH_MENU_BY_ID_FAILURE`;

const CREATE_MENU = `${DOMAIN_NAME}@CREATE_MENU`;
const CREATE_MENU_SUCCESS = `${DOMAIN_NAME}@CREATE_MENU_SUCCESS`;
const CREATE_MENU_FAILURE = `${DOMAIN_NAME}@CREATE_MENU_FAILURE`;

const UPDATE_MENU = `${DOMAIN_NAME}@UPDATE_MENU`;
const UPDATE_MENU_SUCCESS = `${DOMAIN_NAME}@UPDATE_MENU_SUCCESS`;
const UPDATE_MENU_FAILURE = `${DOMAIN_NAME}@UPDATE_MENU_FAILURE`;

const DELETE_MENU = `${DOMAIN_NAME}@DELETE_MENU`;
const DELETE_MENU_SUCCESS = `${DOMAIN_NAME}@DELETE_MENU_SUCCESS`;
const DELETE_MENU_FAILURE = `${DOMAIN_NAME}@DELETE_MENU_FAILURE`;

// Permissions actions
const FETCH_PERMISSIONS = `${DOMAIN_NAME}@FETCH_PERMISSIONS`;
const FETCH_PERMISSIONS_SUCCESS = `${DOMAIN_NAME}@FETCH_PERMISSIONS_SUCCESS`;
const FETCH_PERMISSIONS_FAILURE = `${DOMAIN_NAME}@FETCH_PERMISSIONS_FAILURE`;

// UI actions
const OPEN_MENU_DIALOG = `${DOMAIN_NAME}@OPEN_MENU_DIALOG`;
const CLOSE_MENU_DIALOG = `${DOMAIN_NAME}@CLOSE_MENU_DIALOG`;
const OPEN_DELETE_DIALOG = `${DOMAIN_NAME}@OPEN_DELETE_DIALOG`;
const CLOSE_DELETE_DIALOG = `${DOMAIN_NAME}@CLOSE_DELETE_DIALOG`;
const SET_SELECTED_MENU = `${DOMAIN_NAME}@SET_SELECTED_MENU`;
const CLEAR_SELECTED_MENU = `${DOMAIN_NAME}@CLEAR_SELECTED_MENU`;

export {
    FETCH_MENUS,
    FETCH_MENUS_SUCCESS,
    FETCH_MENUS_FAILURE,
    FETCH_MENU_BY_ID,
    FETCH_MENU_BY_ID_SUCCESS,
    FETCH_MENU_BY_ID_FAILURE,
    CREATE_MENU,
    CREATE_MENU_SUCCESS,
    CREATE_MENU_FAILURE,
    UPDATE_MENU,
    UPDATE_MENU_SUCCESS,
    UPDATE_MENU_FAILURE,
    DELETE_MENU,
    DELETE_MENU_SUCCESS,
    DELETE_MENU_FAILURE,
    FETCH_PERMISSIONS,
    FETCH_PERMISSIONS_SUCCESS,
    FETCH_PERMISSIONS_FAILURE,
    OPEN_MENU_DIALOG,
    CLOSE_MENU_DIALOG,
    OPEN_DELETE_DIALOG,
    CLOSE_DELETE_DIALOG,
    SET_SELECTED_MENU,
    CLEAR_SELECTED_MENU
};
